export const ActionTypes = {
	OPTIONS_GET: 'OPTIONS_GET',
	FEATURES_GET: 'FEATURES_GET',
	SETTINGS_GET: 'SETTINGS_GET',
	FIELDS_EDIT: 'FIELDS_EDIT',
	ANALYTICS_TRACK: 'ANALYTICS_TRACK'
};
